module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2yMcN"))).then(() => module.bundle.root('iDabs'));